module.exports = __webpack_public_path__ + "img/background.ed12abe4.jpg";